import { RECORD_TYPES_PREFIX, STATUS_ACTIVE, STATUS_INACTIVE, VISIBILITY_PRIVATE, VISIBILITY_SHARED } from './constants';
export var getVisibleColumnsKey = function (entityTypeId) { return "lists-visible-columns-".concat(entityTypeId); };
export var getFilters = function (appliedFilters) {
    // @ts-ignore:next-line
    return appliedFilters && Object.keys(appliedFilters).filter(function (filterKey) { return appliedFilters[filterKey] === true; });
};
export var getListsFilterUrlParams = function (filters, size, offset) {
    var params = new URLSearchParams();
    var entityTypeIdsArray = [];
    if (filters.includes(STATUS_ACTIVE) && !filters.includes(STATUS_INACTIVE)) {
        params.append('active', 'true');
    }
    else if (filters.includes(STATUS_INACTIVE) && !filters.includes(STATUS_ACTIVE)) {
        params.append('active', 'false');
    }
    if (filters.includes(VISIBILITY_PRIVATE) && !filters.includes(VISIBILITY_SHARED)) {
        params.append('private', 'true');
    }
    else if (filters.includes(VISIBILITY_SHARED) && !filters.includes(VISIBILITY_PRIVATE)) {
        params.append('private', 'false');
    }
    for (var _i = 0, filters_1 = filters; _i < filters_1.length; _i++) {
        var filter = filters_1[_i];
        if (filter.startsWith(RECORD_TYPES_PREFIX)) {
            entityTypeIdsArray.push(filter.slice(RECORD_TYPES_PREFIX.length));
        }
    }
    var entityTypeIdsString = entityTypeIdsArray.join(',');
    if (entityTypeIdsString)
        params.append('entityTypeIds', entityTypeIdsString);
    if (offset)
        params.append('offset', offset.toString());
    if (size)
        params.append('size', size.toString());
    return params;
};
